<script>
  import { t } from '../../i18n/index.js';

  let { onConfirm, onCancel } = $props();
</script>

<div class="dialog-overlay">
  <div class="dialog-content">
    <h3 class="text-xl font-bold mb-3">{t('modeSwitch.title')}</h3>
    <p class="text-gray-400 mb-6">{@html t('modeSwitch.message')}</p>
    <div class="flex gap-3">
      <button
        onclick={onCancel}
        class="flex-1 py-3 px-4 bg-gray-700 hover:bg-gray-600 rounded-xl font-medium transition-colors"
      >
        {t('modeSwitch.cancel')}
      </button>
      <button
        onclick={onConfirm}
        class="flex-1 py-3 px-4 bg-red-600 hover:bg-red-500 rounded-xl font-bold transition-colors"
      >
        {t('modeSwitch.confirm')}
      </button>
    </div>
  </div>
</div>

<style>
  .dialog-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    padding: 1rem;
  }

  .dialog-content {
    background: #1f2937;
    border-radius: 1rem;
    padding: 2rem;
    max-width: 320px;
    width: 100%;
    text-align: center;
  }
</style>
